import { Icon, Text } from '@pairy/pds-react';
import { MouseEvent } from 'react';
import cn from 'classnames';

import * as Styled from '../index.styles';

interface Props {
  href: string;
  isDisabled: boolean;
  handleDisabledButtonClick: (e: MouseEvent<HTMLButtonElement>) => void;
}

const PreviewButton = ({
  href,
  isDisabled,
  handleDisabledButtonClick,
}: Props) => {
  const handleOpenPreview = () => {
    window.open(href, '_blank', 'noreferrer noopener');
  };

  return (
    <Styled.GrayBorderButton
      className={cn('', {
        'is-disabled': isDisabled,
      })}
      onClick={(e) => {
        e.stopPropagation();
        if (isDisabled) {
          handleDisabledButtonClick(e);
          return;
        }
        handleOpenPreview();
      }}
    >
      <Icon icon="ph:eye" size={17} color="inherit" />
      <Text variant="sm-medium" color="inherit">
        미리보기
      </Text>
    </Styled.GrayBorderButton>
  );
};

export default PreviewButton;
